import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { WorkflowService } from '../../../../../coverpath-common/angular/services/workflow/workflow.service';

@Injectable()
export class ApplicationFormGuard implements CanActivate {

    constructor(private router: Router, private workflowService: WorkflowService) {}

    canActivate() {
        if(this.workflowService.isPreSubmit()){
            return true;
        } else{
            this.router.navigate(['account-center']);
            return false;
        }
    }
}